/// <amd-module name="VSS/Features/Directory/components/DirectoryGrid/NameCell" />
import { InfoIcon } from "VSSUI/InfoIcon";
import { IDirectoryRow } from "./DirectoryGrid.Props";
import * as DirectoryResources from "VSS/Features/Directory/Resources";
import { IDirectoryArtifact } from "DirectoryContracts";
import { Link } from "VSSUI/Link";
import * as React from "react";
import { Tooltip } from "VSSUI/TooltipEx";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";

export interface INameCellProps<T extends IDirectoryArtifact> {
    row: IDirectoryRow<T>;
    onClick: (row: IDirectoryRow<T>, index: number | undefined, ev: Event) => void;
}

/**
 * The name cell renders the name portion of a row and makes it clickable.
 */
export class NameCell<T extends IDirectoryArtifact> extends React.PureComponent<INameCellProps<T>> {
    public render(): JSX.Element {
        const {
            row: {
                data: { name, url },
                errorMessage,
                isDeleted,
                iconProps
            }
        } = this.props;

        return (
            <div className="directory-row-name-cell">
                {iconProps && <VssIcon {...iconProps} className="directory-artifact-icon" />}

                <Tooltip overflowOnly={true} text={name}>
                    <div className="directory-row-title flex-tooltip-host">
                        {isDeleted ? (
                            `${name} (${DirectoryResources.DeletedContent})`
                        ) : (
                            <Link className="directory-title" href={url} onClick={this._onClicked} removeUnderline={true}>
                                {name}
                            </Link>
                        )}
                    </div>
                </Tooltip>
                {this.props.children}
                <div className="directory-row-error">
                    {errorMessage && <InfoIcon infoText={errorMessage} iconProps={{ iconType: VssIconType.fabric, iconName: "Error" }} />}
                    {errorMessage && (
                        <div className="directory-row-error-annoucement screenreader" aria-live="assertive">
                            {errorMessage}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private _onClicked = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        const { row, onClick } = this.props;

        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && onClick) {
            event.preventDefault();
            onClick(row, undefined, event.nativeEvent);
        }
    };
}
